export const defaultState = {
  behaviors: [],
  ratings: [],
  myVotes: [],
};
